import { computed, ref } from 'vue'

export function useDocumentTypeUnicity(mode = 'upload', documentType = null, isNewUpload = false) {
  const documentTypeRef = ref(documentType)
  const modificationMode = ref(mode)

  const requireConfirmation = computed(() => {
    if (!documentTypeRef.value || isNewUpload) {
      return false
    }

    return true === documentTypeRef.value?.unique && true === documentTypeRef.value?.existing
  })

  const confirmationTitle = computed(() => {
    if (!requireConfirmation.value) {
      return ''
    }

    return `document.${modificationMode.value}.confirm.title`
  })

  const confirmationMessage = computed(() => {
    if (!requireConfirmation.value) {
      return ''
    }

    return `document.${modificationMode.value}.confirm.${documentTypeRef.value?.inSignature ? 'messageInSignature' : 'message'}`
  })

  return {
    requireConfirmation,
    confirmationTitle,
    confirmationMessage,
    documentType: documentTypeRef,
    mode: modificationMode,
  }
}
